import { Component } from '@angular/core';
import { BaseDatatableCellComponent } from '../base-datatable-cell.component';

@Component({
  template: `<app-button
    (handleClick)="handleClick($event)"
    [label]="value()"
  />`,
})
export class ActionCellComponent extends BaseDatatableCellComponent {
  handleClick(event: MouseEvent) {
    console.log('Ação clicada!', this.rowData(), event);
  }
}
